import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const videosPlugin = createPlugin({
  id: 'videos',
  routes: {
    root: rootRouteRef,
  },
});

export const VideosPage = videosPlugin.provide(
  createRoutableExtension({
    name: 'VideosPage',
    component: () =>
      import('./components/VideosPage').then(m => m.VideosPage),
    mountPoint: rootRouteRef,
  }),
);
